/**
 * @class Oskari.mapframework.domain.Tool
 *
 * Map Layer Tool
 */
Oskari.clazz.define('Oskari.mapframework.domain.Tool',
/**
 * @method create called automatically on construction
 * @static
 */

function () {
  this._name = null;
  this._iconComponent = null;
  this._title = null;
  this._tooltip = null;
  this._iconCls = null;
  this._callback = null;
  this._types = ['selectedLayers'];
}, {
  /**
   * @method setName
   * Sets name for the tool
   *
   * @param {String} name
   *            style name
   */
  setName: function setName(name) {
    this._name = name;
  },
  /**
   * @method getName
   * Gets name for the tool
   *
   * @return {String} style name
   */
  getName: function getName() {
    return this._name;
  },
  /**
   * @method setTitle
   * Sets title for the tool
   *
   * @param {String} title
   *            tool title
   */
  setTitle: function setTitle(title) {
    this._title = title;
  },
  /**
   * @method getTitle
   * Gets title for the tool
   *
   * @return {String} tool title
   */
  getTitle: function getTitle() {
    return this._title;
  },
  /**
   * @method setTooltip
   * Set tooltip for tool
   *
   * @param {String} tooltip text
   */
  setTooltip: function setTooltip(tooltip) {
    this._tooltip = tooltip;
  },
  /**
   * @method getTooltip
   * Get tooltip text
   *
   * @return {String} tooltip text
   */
  getTooltip: function getTooltip() {
    return this._tooltip;
  },
  /**
   * @method setIconCls
   * Set optional icon name (e.g. icon-close)
   *
   * @param {String} icon name
   */
  setIconCls: function setIconCls(iconCls) {
    this._iconCls = iconCls;
  },
  /**
   * @method getIconCls
   * Get optional icon name
   *
   * @return {String} icon name
   */
  getIconCls: function getIconCls() {
    return this._iconCls;
  },
  /**
   * @method setIconComponent
   * Set optional icon component (e.g. <EditOutlined/>)
   *
   * @param {ReactComponentElement} iconComponent icon component
   */
  setIconComponent: function setIconComponent(iconComponent) {
    this._iconComponent = iconComponent;
  },
  /**
   * @method getIconComponent
   * Get optional icon component
   *
   * @return {ReactComponentElement} icon component
   */
  getIconComponent: function getIconComponent() {
    return this._iconComponent;
  },
  /**
   * @method setCallback
   * Sets callback definition for tool
   *
   * @param {function} callback code
   *
   */
  setCallback: function setCallback(callback) {
    this._callback = callback;
  },
  /**
   * @method getCallback
   * Get callback code for tool
   *
   * @return {function} callback definition
   */
  getCallback: function getCallback() {
    return this._callback;
  },
  setTypes: function setTypes(types) {
    this._types = types;
  },
  addType: function addType(type) {
    if (!type || this._types.includes(type)) {
      return;
    }
    this._types.push(type);
  },
  getTypes: function getTypes() {
    return this._types;
  }
});